module.exports = "https://coursera_assets.s3.amazonaws.com/images/d8cfb473c2c193212054756b44f3c14c.png";